import _ from 'lodash';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import thunk from 'redux-thunk';
import { browserHistory } from 'react-router';
import { routerMiddleware, LOCATION_CHANGE } from 'react-router-redux';

import reducers from './stores/index';
import scenesData from './data/scenes.json';
import StageActions from './actions/StageActions';
import UserLogActions from './actions/UserLogActions';
import ActionTypes from './constants/ActionTypes';

const reducer = combineReducers(reducers);

function getSceneFromState(state) {
    let route = _.get(state, 'routing.locationBeforeTransitions.pathname', null);
    if (route !== null && route !== '/' && route.substr(-1, 1) === '/') {
        route = route.substr(0, route.length - 1);
    }
    return _.defaultTo(_.find(scenesData, scene => scene.route === route), null);
}

const userDataMiddleware = store => next => (action) => {
    const prevState = store.getState();
    const result = next(action);
    const state = store.getState();

    const prevScene = getSceneFromState(prevState);
    const scene = getSceneFromState(state);
    const prevSceneKey = _.get(prevScene, 'name');
    const sceneKey = _.get(scene, 'name');

    const instability = state.crisis.get('instability');
    const crisis = state.crisis.get('crisis');
    const intensity = crisis ? 'crisis' : state.crisis.get('intensity');

    if (action.type === LOCATION_CHANGE) {
        store.dispatch(StageActions.setScene(sceneKey));

        if (prevScene !== null && !_.get(prevScene, 'index', false)) {
            store.dispatch(UserLogActions.add(prevSceneKey, intensity, instability));
        }
        if (!_.get(scene, 'index', false)) {
            store.dispatch(UserLogActions.clear(sceneKey, intensity, instability));
        }
    } else if (action.type === ActionTypes.CRISIS_UPDATE_INTENSITY) {
        store.dispatch(UserLogActions.add(sceneKey, intensity, instability));
    } else if (action.type === ActionTypes.CRISIS_UPDATE_INSTABILITY) {
        if (prevState.crisis.get('crisis') !== crisis) {
            store.dispatch(UserLogActions.add(sceneKey, intensity, instability));
        }
    } else if (action.type === ActionTypes.COMPLETE_SCENE) {
        store.dispatch(UserLogActions.add(sceneKey, intensity, instability));
    }
    return result;
};

const router = routerMiddleware(browserHistory);
// const logger = createLogger();
const enhancer = applyMiddleware(
    thunk,
    router,
    userDataMiddleware,
);

module.exports = initialState => createStore(reducer, initialState, enhancer);



// WEBPACK FOOTER //
// ./js/store.js